export const DEFAULT_HELP_URLS = {
    ASDA: 'https://wd103.myworkday.com/asda/learning/course/afd398122c971001c1042ba3fe780001?type=9882927d138b100019b928e75843018d',
    SUPPLIER: 'https://supplierportal.asda.uk/supplier?id=kb_article_view&sysparm_article=KB0034791',
};

Object.freeze(DEFAULT_HELP_URLS);

export const DEFAULT_NOTICE_BOARD_FOOTER_URLS = {
    ASDA :
            '<a href="https://one.asda.uk/oneasda?id=sc_cat_item&sys_id=d67d0a661b398ad00f52a797b04bcb89">Raise a case (Asda colleague)</a>',
    SUPPLIER :
            // eslint-disable-next-line max-len
            '<a href="https://supplierportal.asda.uk/supplier?id=sc_cat_item&sys_id=f337587f1b56c110c068fb25464bcb6f&referrer=popular_items">Raise a case (supplier)</a>'
};

export const DEFAULT_NOTICE_BOARD_SECOND_FOOTER_URLS = {
    ASDA :
            '<a href="https://asdauk.sharepoint.com/sites/CTCommunicationsSite/SitePages/Meet-the-Future-Project-Team.aspx">ADR Supporting Material (Asda colleague)</a>',
    SUPPLIER :
            // eslint-disable-next-line max-len
            '<a href="https://www.supplierportal.asda.uk/supplier?id=kb_article_view&sysparm_article=KB0034791">ADR Supporting Material (Supplier)</a>'
};
Object.freeze(DEFAULT_NOTICE_BOARD_FOOTER_URLS);
